/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import Image from '../base-ui/Image'
import { css, useTheme } from '@emotion/react'
import { Link } from '../base-ui'
import { GiHamburgerMenu } from 'react-icons/gi'
import { useDataProvider } from '../../hooks/dataProvider'
import Head from './Head'
import Nav from './Nav'
import SearchModal from '../page-builder/SearchModal'
import { AiOutlineSearch } from 'react-icons/ai'
import AdSelection from '../ads/ad_selection'

function ThemeHeader() {
    const theme = useTheme()
    const { data } = useDataProvider()
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false)
    const headerColor = theme.colors.websiteHeader.color

    useEffect(() => {
        if (!window) return
        var lastScrollTop = 0, delta = 15;
        var onScroll = function () {
            var st = window.pageYOffset || document.documentElement.scrollTop;

            if (Math.abs(lastScrollTop - st) <= delta)
                return;
            if ((st > lastScrollTop) && (lastScrollTop > 0)) {
                // downscroll code
                document.querySelector('header').style.top = '-86px';
            } else {
                // upscroll code
                document.querySelector('header').style.top = '0px';
            }
            lastScrollTop = st;
        };

        window.addEventListener('scroll', onScroll);

        // Clean up the event listener to prevent memory leaks
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [])

    return (
        <>
            <Head {...data?.head} />
            {data?.showHeader !== false && (
                <>
                    <Nav
                        items={data?.menuItems}
                        visible={mobileMenuVisible}
                        onClose={() => setMobileMenuVisible(false)}
                        type="mobile"
                    />
                    <header
                        className={theme.components.websiteHeader.className}
                        css={css`
                            ${theme.components.websiteHeader.style}
                            transition: 0.3s ease;
                            @media (max-width: 1024px) {
                                height: 86px;
                            }
                        `}
                    >
                        <div id="nav-wrapper" className="w-full" style={{ gap: 5 }}>
                            <Link id="logo" href="/">
                                <div id="logo-wrapper">
                                    <Image
                                        noStyle
                                        layout="fill"
                                        objectFit="contain"
                                        alt="logo"
                                        src="/img/project/logo.png"
                                    />
                                </div>
                            </Link>
                            <Nav items={data?.menuItems} />

                            <AdSelection
                                ads={data?.siteAds ?? []}
                                location="site_header_menu"
                                style={{ maxHeight: 60, objectFit: 'contain' }}
                                Wrapper={({ children }) => <div style={{
                                    display: 'inline-flex',
                                    gap: 5,
                                    alignItems: 'center',
                                    maxHeight: '100%',
                                    overflow: 'hidden',
                                    flex: 1,
                                    justifyContent: 'flex-end',
                                }}>{children}</div>}
                            />
                            <div className="flex mr-auto">
                                <SearchModal
                                    trigger={
                                        <button
                                            id="quik-search-btn"
                                            type="button"
                                            className="site-button-link"
                                            css={css`
                                                svg {
                                                    font-size: 24px;
                                                    color: ${theme.colors
                                                    .primary};
                                                    font-weight: 100;
                                                    margin: 0 1rem;
                                                }
                                            `}
                                        >
                                            <AiOutlineSearch />
                                        </button>
                                    }
                                />
                                <button
                                    className="flex-item lg:hidden"
                                    css={css`
                                        color: ${headerColor};
                                        border-right: 1px solid
                                            ${theme.colors.lightGray};
                                        padding: 0 1rem;
                                    `}
                                    onClick={() => {
                                        setMobileMenuVisible(true)
                                    }}
                                >
                                    <GiHamburgerMenu className="text-3xl" />
                                </button>
                            </div>
                        </div>
                    </header>
                </>
            )}
        </>
    )
}

export default ThemeHeader
